import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  MenuItem,
  RadioGroup,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import Radio from "@mui/material/Radio";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InfoIcon from "@mui/icons-material/Info";
import { useEffect, useState } from "react";
import PreviewCohorts from "./PreviewCohorts";
import NavBarNew from "../NavBarNew";
import { positions, useAlert } from "react-alert";
import { useSelector } from "react-redux";

const messageTones = [
  { title: "Family Physician 👨🏽‍⚕️", value: "empathetic" },
  { title: "Corporate Hospital 🏥", value: "professional" },
  { title: "Data Driven 👨🏽‍💻", value: "data_driven" },
];

const tooltipTitles = {
  empathetic: "A warm, personalized explanation for the patient's well-being.",
  professional: "A professional, precise delivery of results.",
  data_driven: "Analytical insights based on key metrics and trends.",
};

const Cohorts = () => {
  const location = useLocation();
  const alert = useAlert();
  const { empathetic, professional, data_driven } = useSelector(
    (state) => state.messagingConfig
  );
  const { state } = location || {};
  const [tone, setTone] = useState("empathetic");
  const [whatsappMessage, setWhatsappMessage] = useState("");
  const [contact, setContact] = useState("");
  const [loader, setLoader] = useState(false);
  const [chooseCohort, setChooseCohort] = useState("");
  const [open, setOpen] = useState(false);
  const [phoneError, setPhoneError] = useState("");
  const [validPhone, setValidPhone] = useState(true);
  console.log("state", state);

  useEffect(() => {
    if (state?.state?.cohort_data?.all_cohorts) {
      setChooseCohort(
        Object.keys(state.state.cohort_data.all_cohorts)?.[0] || ""
      );
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const getSpecificPrompt = () => {
    let result = "";
    if (tone === "empathetic") {
      result = empathetic;
    } else if (tone === "professional") {
      result = professional;
    } else {
      result = data_driven;
    }
    console.log("aswesd", result);
    return result;
  };

  const createPayload = () => {
    let result = {
      report_id: "NG1234",
      age: 34,
      gender: "Male",
      tone: tone,
      appointment_link: "https://www.niroggyan.com/",
      phone_number: "7678277891",
      org_name: "NirogGyan",
      prompt_data: getSpecificPrompt(),
      cohort_data: {
        main_cohort: state?.state?.cohort_data?.main_cohort || "",
        sub_cohort: state?.state?.cohort_data?.sub_cohort || "",
        all_cohorts: state?.state?.cohort_data?.all_cohorts || {},
      },
    };
    return result;
  };

  const fetchMessage = async () => {
    setLoader(true);
    const apiUrl =
      "https://jyxmm1ky78.execute-api.ap-south-1.amazonaws.com/Testing/whatsappMessaging/api/generate-message";
    const payload = createPayload();
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "API-Key": "abc123",
      },
      body: JSON.stringify(payload),
    };

    try {
      const response = await fetch(apiUrl, options);
      const data = await response.json();
      if (data?.success) {
        alert.success(
          <span className="alertError">
            Successfully generated the message
          </span>,
          {
            position: positions.TOP_CENTER,
          }
        );
        setWhatsappMessage(data.data.complete_message);
      } else {
        alert.error(<span className="alertError">{data.message}</span>, {
          position: positions.TOP_CENTER,
        });
      }
    } catch (e) {
      console.log("Something went wrong. Please try again!");
      alert.error(
        <span className="alertError">
          Something went wrong. Please try again!.
        </span>,
        {
          position: positions.TOP_CENTER,
        }
      );
    } finally {
      setLoader(false);
    }
  };

  const handleContactChange = (e) => {
    const input = e.target.value;
    const phoneRegex = /^\+?[1-9]\d{1,14}$/; // E.164 format
    setContact(e.target.value);

    if (!input || phoneRegex.test(input)) {
      setPhoneError(""); // Clear error if input is valid
    } else {
      setPhoneError("Invalid phone number."); // Set error for invalid input
    }
  };

  const sendMessage = () => {
    if (phoneError || !contact) {
      alert.error(
        <span className="alertError">Please enter a valid phone number</span>,
        {
          position: positions.TOP_CENTER,
        }
      );
      return;
    }
    if (!whatsappMessage) {
      alert.error(<span className="alertError">Your message in empty</span>, {
        position: positions.TOP_CENTER,
      });
      return;
    }
    let phoneNumber = contact;
    if (!phoneNumber.startsWith("+")) {
      phoneNumber = `+91${phoneNumber}`;
    }
    const message = encodeURIComponent(whatsappMessage);
    const url = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <NavBarNew />
      <Box sx={{ padding: "0px 8%" }} mt={3}>
        <Box px={4} py={3} sx={{ background: "#F7F9FD" }}>
          <Typography variant="h7">Cohorts and Parameters</Typography>
          <Box mt={2}>
            {/* <Button onClick={() => setOpen(true)} variant="outlined">
              View Data
            </Button> */}
            <Typography
              onClick={() => setOpen(true)}
              sx={{
                fontSize: "18px",
                cursor: "pointer",
                color: "blue",
                "&:hover": { textDecoration: "underline" },
              }}
            >
              View Parameters
            </Typography>
            <PreviewCohorts
              open={open}
              handleClose={handleClose}
              parameterData={
                state?.state?.cohort_data?.all_parameters_observed_values
              }
            />
          </Box>
          <Box mt={3}>
            <Typography variant="h8" mb={1}>
              Select Cohort
            </Typography>
            <Stack
              direction={"row"}
              alignItems={"center"}
              gap={4}
              flexWrap={"wrap"}
            >
              <FormControl sx={{ m: 1, width: 250 }} size="small">
                <Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  value={chooseCohort}
                  label=""
                  onChange={(e) => setChooseCohort(e.target.value)}
                >
                  {state?.state?.cohort_data?.all_cohorts &&
                    Object.keys(state.state.cohort_data.all_cohorts).map(
                      (each) => (
                        <MenuItem key={each} value={each}>
                          {each}
                        </MenuItem>
                      )
                    )}
                </Select>
              </FormControl>
              <Typography variant="body9" sx={{ textDecoration: "underline" }}>
                Your highest priority cohort is auto selected.
              </Typography>
            </Stack>
          </Box>
          <Box mt={2}>
            <Typography variant="h8" mb={2}>
              Select Tone of Message
            </Typography>
            <Box>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  value={tone}
                  onChange={(e) => setTone(e.target.value)}
                >
                  {messageTones.map((each) => (
                    <FormControlLabel
                      key={each}
                      value={each.value}
                      control={<Radio size="small" />}
                      label={
                        <Stack direction={"row"} alignItems={"center"} gap={2}>
                          <Typography variant="h9">{each.title}</Typography>
                          <Tooltip
                            title={tooltipTitles[each.value]}
                            placement="top"
                            arrow
                          >
                            <InfoIcon
                              sx={{ color: "#1F78FF", fontSize: "18px" }}
                            />
                          </Tooltip>
                        </Stack>
                      }
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </Box>
          </Box>
          <Box
            mt={2}
            sx={{
              display: "flex",
              justifyContent: {
                md: "flex-end",
                sm: "flex-start",
                xs: "flex-start",
              },
              width: { md: "62%", sm: "100%", xs: "100%" },
            }}
          >
            <Button
              variant="custom_msg"
              sx={{ width: "170px", height: "35px" }}
              onClick={fetchMessage}
              disabled={loader}
            >
              {loader ? (
                <CircularProgress size={20} sx={{ color: "#fff" }} />
              ) : (
                "Generate Message"
              )}
            </Button>
          </Box>
        </Box>
        <Box px={4} py={2}>
          <Stack direction={"row"} alignItems={"center"} gap={2}>
            <Typography variant="h8">Message</Typography>
            <DriveFileRenameOutlineOutlinedIcon />
          </Stack>
          <Box mt={1}>
            <TextField
              id="outlined-multiline-flexible"
              label=""
              multiline
              rows={6}
              fullWidth
              sx={{ maxWidth: "600px" }}
              value={loader ? "Loading..." : whatsappMessage}
              onChange={(e) => setWhatsappMessage(e.target.value)}
            />
            {!whatsappMessage ? (
              <Typography mt={1} sx={{ fontSize: "12px", display: "block" }}>
                Please click on "Generate Message" button to view the message
              </Typography>
            ) : (
              ""
            )}
          </Box>
          <Box mt={4}>
            <Typography variant="h8">
              Enter your mobile number to share it on whatsapp
            </Typography>
            <Stack
              mt={1.5}
              direction={"row"}
              alignItems={"center"}
              gap={2}
              flexWrap={"wrap"}
            >
              <TextField
                sx={{ width: "300px" }}
                id="outlined-basic"
                label=""
                variant="outlined"
                placeholder="Enter you mobile number"
                size="small"
                value={contact}
                onChange={(e) => handleContactChange(e)}
              />

              <Button
                sx={{
                  background: "#2DB841",
                  color: "#fff",
                  "&:hover": {
                    border: "1px solid #2DB841",
                    background: "inherit",
                    color: "#000000",
                  },
                }}
                onClick={sendMessage}
                variant="custom_msg"
              >
                <WhatsAppIcon />{" "}
                <Typography ml={1} sx={{ color: "inherit", fontSize: "16px" }}>
                  Send to WhatsApp
                </Typography>
              </Button>
            </Stack>
            {phoneError ? (
              <Typography mt={1} sx={{ fontSize: "12px", color: "red" }}>
                {phoneError}
              </Typography>
            ) : (
              ""
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Cohorts;
